import { Component, DestroyRef, inject, input, output, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { timer } from 'rxjs';

@Component({
  imports: [IconBadgeComponent, IconComponent, TranslateModule, MatButtonModule],
  selector: 'app-filtered-creator-badge',
  styleUrl: './filtered-creator-badge.component.scss',
  templateUrl: './filtered-creator-badge.component.html',
})
export class FilteredCreatorBadgeComponent {
  public readonly creatorIcon = input<string | null | undefined>(undefined);
  public readonly creatorName = input<string | null>('');

  public readonly removed = output<void>();

  public readonly leaving = signal(false);

  private readonly destroyRef = inject(DestroyRef);

  public startLeave(): void {
    this.leaving.set(true);
    timer(200)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.removed.emit());
  }
}
